<template>
  <!-- Sidebar -->
   
  <div
    name="sidebar"
    class="flex flex-col my-4 top-14 left-0 w-16 md:w-17 h-screen  transition-all duration-300 z-10 rounded-lg overflow-y-auto pb-6"
  >

      <div class="h-19.5">
        <i class="absolute top-0 right-0 hidden p-4 opacity-50 cursor-pointer fas fa-times text-slate-400 xl:hidden" sidenav-close></i>
        <a class="block px-8 py-6 m-0 text-sm whitespace-nowrap text-slate-700" href="javascript:;" target="_blank">
          <img v-bind:src="setLogo()" class="inline h-full max-w-full transition-all duration-200 ease-nav-brand max-h-8 opacity-75" alt="main_logo" />
        </a>
      </div>

      <hr class="h-1 mt-0 bg-gradient-to-r from-transparent via-purple-500 to-transparent" />

    <div class="overflow-y-auto overflow-x-hidden flex flex-col flex-grow">
      <div class="flex flex-col flex-grow justify-between">
        <ul class="flex flex-col pb-4 pt-4" v-if="!isContentAdmin">
          <li class="px-5 hidden md:block" v-if="isSubjectBased">
            <div class="flex flex-row items-center pt-3 pb-1">
              <div class="list-heading">Subject</div>
            </div>
          </li>

          <li class="px-5 pb-4 pt-2 hidden md:block" v-if="isSubjectBased">
            <div class="flex flex-row items-center pb-1">
              <router-link to="/subjects" class="focus:outline-none group">
                <div class="list-heading-subject">
                  {{ subjectTitle }}
                  <i class="fas fa-chevron-down pl-2" title="Subjects"></i>
                </div>
              </router-link>
            </div>
          </li>

          <li class="mt-0.5 w-full">
             <router-link to="/" 
              class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
            <div
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                  <i class="fas fa-home" title="Home"></i>
              </div>
              <span class="ml-1 duration-300 opacity-100 pointer-events-none ease-soft  group-hover:text-gray-400">Dashboard</span>
             </router-link>
          </li>


          <li class="mt-1 w-full" v-if="showForSchool">
            <router-link 
              to="/planning"
              class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <div
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-grip-horizontal" title="Home"></i>
              </div>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-300">
                <span v-if="currentUser.isSecondaryBased"> Core PE </span>
                <span v-else>Planning</span>
              </span>
            </router-link>
          </li>

          <li class="mt-1 w-full">
            <router-link
              to="/library"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <div
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5 group-hover:text-gray-300"
              >
                <i class="fas fa-photo-video"></i>
              </div>
              <span class="bar-list-item-title  ease-soft  group-hover:text-gray-400">
                Library
              </span>
            </router-link>
          </li>


            <li class="w-full mt-4">
            <h6 class="list-heading opacity-60">School</h6>
          </li>

          <li>
            <router-link
              :to="showForSchool ? '/reports' : '/school-report-list'"
                class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-file-contract" title="Home"></i>
              </span>
              <span class="bar-list-item-title  ease-soft  group-hover:text-gray-400"
                >Reporting</span
              >
            </router-link>
          </li>

          <li v-if="1 === 5" class="mt-1 w-full">
            <router-link
              to="/wellbeing"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-volume-up"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-400">
                Pupil Voice
              </span>
            </router-link>
          </li>

          <li class="mt-1 w-full">
            <router-link
              to="/events"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5 group-hover:text-gray-300"
              >
                <i class="fas fa-calendar-alt" title="Events"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-400"
                >Events</span
              >
            </router-link>
          </li>

          <li class="mt-1 w-full">
            <router-link
              to="/activities"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-volleyball-ball" title="Extra Curricular"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-400"
                >Extra Curricular</span
              >
            </router-link>
          </li>

          <li class="mt-1 w-full" v-if="!currentUser.isSecondaryBased && showForSchool">
            <router-link
              to="/swimming"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-swimming-pool"></i>
              </span>
              <span class="bar-list-item-title  ease-soft  group-hover:text-gray-400">
                Swimming
              </span>
            </router-link>
          </li>
          <li class="mt-1 w-full" v-if="!currentUser.isSecondaryBased">
            <router-link
              to="/maxwhitlock"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-dumbbell"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-400">
                Max Whitlock Gym
              </span>
            </router-link>
          </li>

          <li class="mt-1 w-full" v-if="1===4">
            <router-link
              to="/cpd"
              class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-chalkboard"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-400">
                CPD
              </span>
            </router-link>
          </li>
          <li class="mt-1 w-full" v-if="showForSchool">
            <router-link
              to="/health"
                class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-heart"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-400"
                >Personal Challenge </span
              >
            </router-link>
          </li>
                   <li class="mt-1 w-full" v-if="showForSchool">
            <router-link
              to="/dance"
                class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-theater-masks"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-400"
                >Dance </span
              >
            </router-link>
          </li>
    
    

   <li class="w-full mt-4">
            <h6 class="list-heading opacity-60">Manage</h6>
          </li>

                  <li v-if="showForSchool">
            <router-link
              to="/toolbox"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-toolbox"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-400">
                Toolbox
              </span>
            </router-link>
          </li>

          <li class="mt-1 w-full">
            <router-link
              to="/my-content"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5 group-hover:text-gray-300"
              >
                <i class="fas fa-file"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-400"
                >My Content</span
              >
            </router-link>
          </li>

          <li class="mt-1 w-full" v-if="showForCompany">
            <router-link
              to="/schools"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5  group-hover:text-gray-300"
              >
                <i class="fas fa-school"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-400"
                >Schools</span
              >
            </router-link>
          </li>

          <li class="mt-1 w-full" v-if="showForCompany && 3 === 33">
            <router-link
              to="/notices"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5 group-hover:text-gray-300"
              >
                <i class="fas fa-comment"></i>
              </span>
              <span class="bar-list-item-title ease-soft  group-hover:text-gray-300"
                >Notices</span
              >
            </router-link>
          </li>

          <li class="mt-1 w-full">
            <router-link
              to="/settings/configuration/planning"
              class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5 group-hover:text-gray-300"
              >
                <i class="fas fa-cog"></i>
              </span>
              <span class="bar-list-item-title  ease-soft  group-hover:text-gray-300"
                >Settings</span
              >
            </router-link>
          </li>
        </ul>

        <ul v-if="isContentAdmin">
         
   <li class="w-full mt-4">
            <h6 class="list-heading opacity-60">Main Menu</h6>
          </li>


          <li>
            <router-link
              to="/my-content"
              class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5 group-hover:text-gray-300"
              >
                <i class="fas fa-file"></i>
              </span>
              <span class="bar-list-item-title group-hover:text-gray-300"
                >Content</span
              >
            </router-link>
            <router-link
              to="/admin/schools-admin"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5 group-hover:text-gray-300"
              >
                <i class="fas fa-user"></i>
              </span>
              <span class="bar-list-item-title group-hover:text-gray-300"
                >Pupil Imports</span
              >
            </router-link>

            <router-link
              to="/notices"
                class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5 group-hover:text-gray-300"
              >
                <i class="fas fa-comment"></i>
              </span>
              <span class="bar-list-item-title group-hover:text-gray-300"
                >Notices</span
              >
            </router-link>

            <router-link
              to="/admin/resource-library"
               class="bar-list-item py-2.7 ease-nav-brand whitespace-nowrap focus:outline-none group"
            >
              <span
                class="bar-list-item-icon shadow-soft-2xl  xl:p-2.5 group-hover:text-gray-300"
              >
                <i class="fas fa-book"></i>
              </span>
              <span class="bar-list-item-title group-hover:text-gray-300"
                >Resources</span
              >
            </router-link>
          </li>
          <li class="px-5 hidden md:block" @click="logout()">
            <div class="flex flex-row items-center pt-6 pb-1">
              <div class="list-heading cursor-pointer text-red-500 opacity-100">
                Logout
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { postMixin } from "@/mixins/postMixin.js";

export default {
  name: "sidebar",
  mixins: [postMixin],

  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      subjects: "subjects",
    }),
    displaName() {
      return this.currentUser.schoolName;
    },
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    showForCompany() {
      return this.currentUser.isSchool == false;
    },
    hasTimelineModule() {
      return this.currentAccess.timelineAccess;
    },
    hasSettingsAccess() {
      return this.currentAccess.configAccess;
    },
    hasAdminAccess() {
      return this.currentUser.hasAdmin;
    },
    isContentAdmin() {
      return this.currentUser.isContentAdmin;
    },
    isSubjectBased() {
      return this.subjects.isBased;
    },
    subjectTitle() {
      if (this.subject != undefined) {
        return this.subject.title;
      }
    },
    isOnFree() {
      return this.currentUser.isOnFree === true;
    },
  },
  created() {},
  mounted() {
    if (this.subject === undefined) {
      let defaultSubject = this.subjects.defaultSubject;
      this.$store.commit("setSubject", defaultSubject);
      this.subject = defaultSubject;
    }

    this.fetchNotices();
    this.$watch(
      () => this.$route.path,
      (to, from) => {
        //console.log('route path has changed from ' +from+' to '+to )
        this.fetchNotices();
      }
    );
  },
  data() {
    return {
      subject: this.$store.getters.subject,
    };
  },
  methods: {
    setLogo() {
      return (
        // "/static/images/domains/" + this.currentUser.s choolLogo + "-small.png"
        "/static/images/passport-side-logo.png"
      );
    },
    getUserInitials() {
      return this.currentUser.schoolName
        .split(" ")
        .map((n) => n[0])
        .join("")
        .substring(0, 3);
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
/*****
Side Bar list
******/

.list-heading {
  @apply pl-6 ml-2 font-bold leading-tight uppercase text-xs ;
}

.list-heading-subject {
  @apply text-sm font-bold tracking-wide text-red-600 opacity-75 uppercase;
}

.bar-list-item {
  @apply text-sm  my-0 mx-4 flex items-center px-4 transition-colors;
}

.bar-list-item-title {
  @apply ml-1 duration-300 opacity-100 pointer-events-none  truncate;
}

.bar-list-item-icon {
  @apply  mr-2 flex h-8 w-8 items-center justify-center rounded-lg bg-white bg-center stroke-0 text-center;
}

.bar-list-item.router-link-exact-active,
.bar-list-item.active {
  @apply text-sm  my-0 mx-4 flex items-center rounded-lg bg-white px-4 font-semibold ;
}

.bar-list-item.router-link-exact-active span,
.bar-list-item.active span {
  @apply text-action-blue font-semibold;
}

.bar-list-item.router-link-exact-active:hover,
.bar-list-item.active:hover {
  @apply opacity-100 text-red-500;
}

.bar-list-item.router-link-exact-active .bar-list-item-icon,
.bar-list-item.active .bar-list-item-icon {
  @apply text-white  bg-gradient-to-tl from-purple-700 to-pink-500  mr-2 flex h-8 w-8 items-center justify-center rounded-lg bg-white bg-center stroke-0 text-center;
}

</style>